import './state/appointments/reducers/neb-appointment-reducer-public';

import * as appointmentApiClient from '../neb-api-client/src/appointment-api-client';
import { parseDate } from '../neb-utils/date-util';

const __buildErrorEvent = (message, type, status) => ({
  type,
  createError: message,
  status,
});

const __dispatchCreatedEvent = async (dispatch, response, type) => {
  const {
    data: [createdAppointment],
  } = await response;

  createdAppointment.start = parseDate(createdAppointment.start).toDate();
  createdAppointment.end = parseDate(createdAppointment.end).toDate();

  dispatch({
    type,
    item: createdAppointment,
  });

  return createdAppointment;
};

const __dispatchError = (dispatch, error, type, status = 500) => {
  dispatch(__buildErrorEvent(error, type, status));
};

export const createAppointment = appointment => async dispatch => {
  dispatch({
    type: 'APPOINTMENT_CREATING_PUBLIC',
  });

  try {
    const response = await appointmentApiClient.createAppointment(appointment);

    if (response.count <= 0) {
      return __dispatchError(
        dispatch,
        new Error('An Unknown Error Occurred'),
        'APPOINTMENT_CREATE_ERROR_PUBLIC',
      );
    }

    return __dispatchCreatedEvent(
      dispatch,
      response,
      'APPOINTMENT_CREATED_PUBLIC',
    );
  } catch (e) {
    __dispatchError(dispatch, e, 'APPOINTMENT_CREATE_ERROR_PUBLIC');

    throw e;
  }
};

export const rescheduleAppointment = appointment => async dispatch => {
  dispatch({
    type: 'APPOINTMENT_RESCHEDULING_PUBLIC',
  });

  try {
    const response = await appointmentApiClient.updateAppointment(
      appointment.id,
      'reschedule',
      appointment,
    );

    if (response.count <= 0) {
      return __dispatchError(
        dispatch,
        new Error('An Unknown Error Occurred'),
        'APPOINTMENT_RESCHEDULE_ERROR_PUBLIC',
      );
    }

    return __dispatchCreatedEvent(
      dispatch,
      response,
      'APPOINTMENT_RESCHEDULED_PUBLIC',
    );
  } catch (e) {
    __dispatchError(dispatch, e, 'APPOINTMENT_RESCHEDULE_ERROR_PUBLIC');

    throw e;
  }
};

export const cancelAppointment = appointment => async dispatch => {
  dispatch({
    type: 'APPOINTMENT_CANCELING_PUBLIC',
  });

  try {
    const response = await appointmentApiClient.updateAppointment(
      appointment.id,
      'cancel',
      {
        ...appointment,
        custom: false,
      },
    );

    if (response.count > 0) {
      __dispatchError(
        dispatch,
        new Error('An Unknown Error Occurred'),
        'APPOINTMENT_CANCEL_ERROR_PUBLIC',
      );

      return;
    }

    dispatch({
      type: 'APPOINTMENT_CANCELED_PUBLIC',
      item: null,
    });
  } catch (e) {
    __dispatchError(dispatch, e, 'APPOINTMENT_CANCEL_ERROR_PUBLIC');

    throw e;
  }
};
